module.exports = __webpack_public_path__ + "img/alfy-logo-100.bd064a53.png";